export const WYSIWYG_BUTTONS = [
  { action: 'clean'              , tooltip: 'Clean'             , icon: 'clear'                  },
  { action: 'undo'               , tooltip: 'Undo'              , icon: 'undo'                   },
  { action: 'redo'               , tooltip: 'Redo'              , icon: 'redo'                   },
  { action: 'removeFormat'       , tooltip: 'Remove formatting' , icon: 'format_clear'           },
  { action: 'bold'               , tooltip: 'Bold'              , icon: 'format_bold'            },
  { action: 'italic'             , tooltip: 'Italic'            , icon: 'format_italic'          },
  { action: 'underline'          , tooltip: 'Underline'         , icon: 'format_underline'       },
  { action: 'justifyleft'        , tooltip: 'Left align'        , icon: 'format_align_left'      },
  { action: 'justifycenter'      , tooltip: 'Center align'      , icon: 'format_align_center'    },
  { action: 'justifyright'       , tooltip: 'Right align'       , icon: 'format_align_right'     },
  { action: 'justifyfull'        , tooltip: 'Right align'       , icon: 'format_align_justify'   },
  { action: 'insertorderedlist'  , tooltip: 'Numbered list'     , icon: 'format_list_numbered'   },
  { action: 'insertunorderedlist', tooltip: 'Dotted list'       , icon: 'format_list_bulleted'   },
  { action: 'formatblock'        , tooltip: 'Quote'             , icon: 'format_quote'           },
  { action: 'outdent'            , tooltip: 'Delete indentation', icon: 'format_indent_decrease' },
  { action: 'indent'             , tooltip: 'Add indentation'   , icon: 'format_indent_increase' },
  { action: 'makehyperlink'      , tooltip: 'Hyperlink'         , icon: 'insert_link'            }
];

export const FORMAT_OPTIONS = [
  { value: 'h1', title: 'Title 1' },
  { value: 'h2', title: 'Title 2' },
  { value: 'h3', title: 'Title 3' },
  { value: 'h4', title: 'Title 4' },
  { value: 'h5', title: 'Title 5' },
  { value: 'h6', title: 'Subtitle' },
  { value: 'p',  title: 'Paragraph' }
];

export const FONTS = [
  'Arial',
  'Arial Black',
  'Courier New',
  'Montserrat',
  'Public Sans',
  'Times New Roman'
];

export const FONT_SIZES = [
  { value: 1, title: '7.5 pt' },
  { value: 2, title: '10 pt' },
  { value: 3, title: '12 pt' },
  { value: 4, title: '13.5 pt' },
  { value: 5, title: '18 pt' },
  { value: 6, title: '24 pt' },
  { value: 7, title: '36 pt' }
];

export const COLORS = [
  { value: 'red', title: 'Red' },
  { value: 'blue', title: 'Blue' },
  { value: 'green', title: 'Green' },
  { value: '#004953', title: 'Midnight Green' },
  { value: '#00786A', title: 'Emerald Dark' },
  { value: '#DD3292', title: 'Magenta'},
  { value: 'black', title: 'Black' },
  { value: '#EEEEEF', title: 'Light Gray'},
  { value: 'white', title: 'White' }
];

export const SIGNATURES = [
  { value: '' , title: 'Signature 1' },
  { value: '' , title: 'Signature 2' }
];
